import { useState } from 'react';
import Image from 'next/legacy/image';
import { BLANK_SHIRT_PATH } from '@lib/utils';

type PlayerImageProps = {
  /** Player photo URL (the backend-provided FFH portrait). */
  src?: string | null;
  /**
   * CDN-hosted kit image from the ffh-backend API, used as the fallback when
   * there is no photo. The backend already picks the goalkeeper variant, so no
   * position-based swapping happens for it. Callers still on legacy player
   * shapes omit it and keep the bundled per-team shirt.
   */
  kitImageUrl?: string;
  className?: string;
  height: number;
  width: number;
  fallbackHeight?: number;
  fallbackWidth?: number;
};

/**
 * Renders a player's photo, falling back to the team kit when no photo URL is
 * given or the photo fails to load.
 */
const PlayerImage = ({
  src,
  kitImageUrl,
  className = 'rounded-full h-full w-auto',
  height,
  width,
  fallbackHeight,
  fallbackWidth
}: PlayerImageProps) => {
  const [hideImage, setHideImage] = useState(false);
  const shouldShowKit = hideImage || !src;

  return shouldShowKit ? (
    <Image
      src={kitImageUrl ?? BLANK_SHIRT_PATH}
      alt="Kit"
      height={fallbackHeight ?? height}
      width={fallbackWidth ?? width}
    />
  ) : (
    <Image
      className={className}
      alt="A"
      onError={() => setHideImage(true)}
      height={height}
      width={width}
      objectFit="contain"
      src={src}
    />
  );
};

export default PlayerImage;
